<template>
  <div lazy-validation>
    <v-layout row>
      <v-flex xs12 sm9>
        <v-radio-group
          row
          v-model="type"
          :disabled="noticeEdit.confirm === 'A'"
        >
          <v-radio
            color="primary"
            :label="$t('surveys.create_survey.institutional')"
            value="I"
          />
          <v-radio
            color="primary"
            :label="
              $t('surveys.create_survey.levels') +
              ' (' +
              selected.levels.length +
              ')'
            "
            value="N"
          />
          <v-radio
            color="primary"
            :label="
              $t('surveys.create_survey.groups') +
              ' (' +
              selected.ggs.length +
              ')'
            "
            value="G"
          />
          <v-radio
            v-show="section !== 'COMMUNITY'"
            color="primary"
            :label="
              $t('surveys.create_survey.subgroups') +
              ' (' +
              selected.subgroupIds.length +
              ')'
            "
            value="SG"
          />
          <v-radio
            v-if="visibilityCollaborators"
            color="primary"
            :label="
              $t('surveys.create_survey.collaborators') +
              ' (' +
              selected.webRoleIds.length +
              ')'
            "
            value="C"
          />
          <v-radio
            color="primary"
            :label="
              $t('surveys.create_survey.students_a') +
              ' (' +
              selected.students.length +
              ')'
            "
            value="E"
          />
        </v-radio-group>
      </v-flex>
      <v-flex xs12 sm3 class="titleSearch" justify-end>
        <v-text-field
          flat
          :label="$t('generic.search')"
          append-outer-icon="search"
          clearable
          solo-inverted
          hide-details
          @keyup="searchStudents"
          @click:append-outer="searchStudents"
          @click:clear="clearSearch"
          v-model="search"
        />
      </v-flex>
    </v-layout>
    <v-layout row>
      <v-slide-x-transition mode="out-in">
        <v-flex xs12 :key="3" v-if="type == 'I'">
          <v-layout justify-center align-center fill-height row wrap>
            <v-flex xs6>
              <v-alert
                style="border-radius: 33px"
                :value="true"
                type="info"
                color="gradiente"
              >
                {{
                  $t(
                    'surveys.create_survey.the_entire_institution_will_be_notified'
                  )
                }}
              </v-alert>
            </v-flex>
          </v-layout>
        </v-flex>
        <v-flex xs12 :key="0" v-if="type == 'N'">
          <lSelection v-model="selected.levels" :array="filteredArray" />
        </v-flex>
        <v-flex xs12 :key="1" v-if="type == 'G'">
          <gSelection v-model="selected.ggs" :array="filteredArray" />
        </v-flex>
        <v-flex xs12 :key="3" v-if="type == 'SG'">
          <sgSelection v-model="selected.subgroupIds" :array="filteredArray" />
        </v-flex>
        <v-flex xs12 :key="4" v-if="type == 'E'">
          <sSelection
            v-model="selected.students"
            :array="filteredArray"
            :showBtnScroll="showBtnScroll"
            @viewMore="viewMoreClick"
          />
        </v-flex>
        <v-flex xs12 :key="5" v-if="type == 'C'">
          <cSelection v-model="selected.webRoleIds" :array="filteredArray" />
        </v-flex>
      </v-slide-x-transition>
    </v-layout>
  </div>
</template>

<script>
import { isEmptyOrNull } from '../../plugins/GeneralMethods'
import cSelection from './ColaboratorsSelection.vue'
import gSelection from './GGsSelection.vue'
import lSelection from './LevelsSelection.vue'
import sgSelection from './SGsSelection.vue'
import sSelection from './StudentsSelection.vue'
export default {
  components: {
    lSelection,
    gSelection,
    sSelection,
    sgSelection,
    cSelection,
  },
  /*
   *La sección representa el lugar donde se muestra este componente, debido a que cada sección puede tener
   *un comportamiento diferente se debe usar la variable "section" para identificarlo, las secciones con
   *diferente comportamiento por el momento son:
   * section: COMMUNITY
   */
  props: ['cancel', 'isEdit', 'noticeFormEdit', 'section'],
  data: () => ({
    search: '',
    type: '',
    selected: {
      levels: [],
      ggs: [],
      students: [],
      subgroupIds: [],
      webRoleIds: [],
      institutional: false,
    },
    studentsFilter: [],
    offset: 0,
    showBtnScroll: false,
    updateStudentsArea: false,
    levels: [],
    ggs: [],
    noticeEdit: {},
  }),
  watch: {
    typeEdit() {
      this.type = this.type_edit
    },
    cancel() {
      if (this.cancel) {
        this.selected = {
          levels: [],
          ggs: [],
          webRoleIds: [],
          subgroupIds: [],
          students: [],
          institutional: false,
        }
        this.type = ''
      }
    },
    _object() {},
    type: {
      handler() {
        switch (this.type) {
          case 'I':
            this.selected.levels = []
            this.selected.ggs = []
            this.selected.students = []
            this.selected.subgroupIds = []
            this.selected.webRoleIds = []
            this.selected.institutional = true
            break
          case 'N':
            this.selected.ggs = []
            this.selected.students = []
            this.selected.subgroupIds = []
            this.selected.webRoleIds = []
            this.selected.institutional = false
            break
          case 'G':
            this.selected.levels = []
            this.selected.students = []
            this.selected.subgroupIds = []
            this.selected.webRoleIds = []
            this.selected.institutional = false
            break
          case 'SG':
            this.selected.levels = []
            this.selected.students = []
            this.selected.ggs = []
            this.selected.webRoleIds = []
            this.selected.institutional = false
            break
          case 'C':
            this.selected.levels = []
            this.selected.students = []
            this.selected.ggs = []
            this.selected.subgroupIds = []
            this.selected.institutional = false
            break
          case 'E':
            this.selected.levels = []
            this.selected.ggs = []
            this.selected.webRoleIds = []
            this.selected.subgroupIds = []
            this.selected.institutional = false
            this.getStudentsByBranch(false)
            break
        }
        this.$emit('typeChange', this.type)
      },
      deep: true,
    },
    selected: {
      handler() {
        this.deleteSelectedOfSearch()
        this.search = ''
        this.$emit('selected', this.selected)
      },
      deep: true,
    },
  },
  computed: {
    visibilityCollaborators() {
      if (this.section === 'COMMUNITY') {
        return false
      }
      return true
    },
    filteredArray() {
      var transformMap = {
        a: '[aá]',
        e: '[eé]',
        i: '[ií]',
        o: '[oó]',
        u: '[uí]',
        A: '[AÁ]',
        E: '[EÉ]',
        I: '[IÍ]',
        O: '[OÓ]',
        U: '[UÚ]',
      }
      var search = this.search ? this.search : ''
      search = search.normalize('NFD').replace(/[\u0300-\u036f]/g, '')
      for (var key in transformMap) {
        search = search.replace(key, transformMap[key])
      }
      var matcher = new RegExp(search, 'i')
      var array = []
      var vm = this

      switch (this.type) {
        case 'N':
          array = this.levels.filter((value) => {
            for (var l in vm.selected.levels) {
              if (vm.selected.levels[l].id == value.id) {
                return false
              }
            }
            return matcher.test([value.typeLevel].join())
          })
          break
        case 'G':
          array = this.ggs.filter((value) => {
            for (var g in vm.selected.ggs) {
              if (vm.selected.ggs[g].id == value.id) {
                return false
              }
            }
            for (var l in vm.selected.levels) {
              if (vm.selected.levels[l].id == value.level.id) {
                return false
              }
            }
            return matcher.test(
              [value.grade + ' ' + value.group, value.level.typeLevel].join()
            )
          })
          break
        case 'SG':
          if (isEmptyOrNull(this.subgroupIds)) {
            return array
          }
          array = Array.from(this.subgroupIds)
          break
        case 'C':
          array = Array.from(this.webRoleIds)
          break
        case 'E':
          array = this.studentsFilter
          break
      }
      return array
    },
  },
  mounted() {
    if (this.noticeFormEdit) {
      this.noticeEdit = JSON.parse(JSON.stringify(this.noticeFormEdit))
      this.setupData()
    }
    this.getTools()
    this.getSubGroups()
    this.getRoles()
    this.getStudentsByBranch(true)
  },
  methods: {
    setupData() {
      if (this.noticeEdit.institutional) {
        this.type = 'I'
      } else if (this.noticeEdit.levels.length > 0) {
        this.type = 'N'
        this.selected.levels = this.noticeEdit.levels
        this.selected.subgroupIds = []
        this.selected.ggs = []
        this.selected.students = []
        this.selected.webRoleIds = []
      } else if (this.noticeEdit.groups.length > 0) {
        this.type = 'G'
        this.selected.levels = []
        this.selected.subgroupIds = []
        this.selected.ggs = this.noticeEdit.groups
        this.selected.students = []
        this.selected.webRoleIds = []
      } else if (this.noticeEdit.subgroups.length > 0) {
        this.type = 'SG'
        this.selected.levels = []
        this.selected.subgroupIds = this.noticeEdit.subgroups
        this.selected.students = []
        this.selected.ggs = []
        this.selected.webRoleIds = []
      } else if (this.noticeEdit.employeeAudience.length > 0) {
        this.type = 'C'
        this.selected.levels = []
        this.selected.ggs = []
        this.selected.subgroupIds = []
        this.selected.students = []
        this.selected.webRoleIds = this.noticeEdit.webRoleIds
      } else if (this.noticeEdit.students.length > 0) {
        this.type = 'E'
        this.selected.levels = []
        this.selected.ggs = []
        this.selected.subgroupIds = []
        this.selected.webRoleIds = []
        this.selected.students = this.noticeEdit.students
      }
    },
    viewMoreClick() {
      this.offset = this.offset + 20
      this.getStudentsByBranch(true)
    },
    getStudentsByBranch(isScroll) {
      var params = {
        search: this.search,
        page_size: 20,
        offset: this.offset,
      }
      this.$store
        .dispatch('student/getByBranch', params)
        .then((response) => {
          let posts = response.data
          this.updateStudentsArea = true
          if (isScroll) {
            if (posts.length) {
              this.studentsFilter = this.studentsFilter.concat(posts)
              this.showBtnScroll = true
            } else {
              this.showBtnScroll = false
            }
          } else {
            this.studentsFilter = posts
            if (posts.length) {
              this.showBtnScroll = true
            } else {
              this.showBtnScroll = false
            }
          }
          this.deleteSelectedOfSearch()
        })
        .catch(() => {})
    },
    getSubGroups() {
      this.$store
        .dispatch('notice/getSubgrupos')
        .then((response) => {
          this.subgroupIds = response.data
          this.type = ''
          this.setupData()
        })
        .catch((error) => {
          console.log(error)
        })
    },
    getRoles() {
      this.$store
        .dispatch('employee/getTools')
        .then((response) => {
          this.webRoleIds = response.data.entity.roles
        })
        .catch((error) => {
          console.log(error)
        })
    },
    getTools() {
      this.$store
        .dispatch('notice/getNoticeTools')
        .then((response) => {
          this.levels = response.data.entity.levels
          this.ggs = response.data.entity.ggs
        })
        .catch(() => {})
    },
    searchStudents() {
      if (this.type === 'E') {
        this.offset = 0
        this.getStudentsByBranch(false)
      }
    },
    clearSearch() {
      if (this.type === 'E') {
        this.offset = 0
        this.search = ''
        this.getStudentsByBranch(false)
      }
    },
    deleteSelectedOfSearch() {
      for (var s in this.selected.students) {
        for (var sf in this.studentsFilter) {
          if (this.selected.students[s].id == this.studentsFilter[sf].id) {
            this.studentsFilter.splice(sf, 1)
          }
        }
      }
    },
  },
}
</script>

<style>
label[for*='descriptionField'],
label[htmlfor*='descriptionField'] {
  top: 0;
  line-height: 13px !important;
}
</style>
